module.exports = __webpack_public_path__ + "static/media/output.b3844136.svg";